const userInfo = {
	state:{
		id:"",
		userName:"",
		userNamePinyin:"",
		sex:"",
		birthday:"",
		unitName:"",
		address:"",
		job:"",
		jobDate:"",
		phone:"",
		email:"",
		education:"",
		educationRemark:"",
		experience:"",
		picUrl:"",
		idCardPic:"",
		majorPic:"",
	}
}

export default userInfo


// WEBPACK FOOTER //
// ./src/utils/store/module/userInfo.js